import ComboList from "./ComboList";
import HeaderWidget from "./HeaderWidget";
import DiscountWidget from "./DiscountWidget";
import { ComboTypesProps } from "../models/PropsInterface";
import "../cssStyles/ComboTypes.css";
import { styleHelper } from "../../helpers/commonFunctions";

const ComboTypes = (props: ComboTypesProps) => {
  return (
    <div className={`vas-row combo_types-container `}>
      {props.config?.discount_widget && (
        <div className={`vas-col-12`}>
          {props.config.discount_widget && (
            <div className={`combo_types-header`}>
              <DiscountWidget
                language={props.language}
                discount_widget={props.config.discount_widget}
              />
            </div>
          )}
        </div>
      )}
      <div
        style={styleHelper({ width: "800px" })}
        className={`vas-col-12 combo_types-header_text ${
          props.language == "ar"
            ? "combo_types-header_text_rtl "
            : "combo_types-header_text_ltr"
        }`}
      >
        {props.config.header_widget && (
          <HeaderWidget header_widget={props.config.header_widget} />
        )}
      </div>
      <div className={`vas-col-12`}>
        {props.config.packages && (
          <ComboList
            setIsSuccessProcess={props.setIsSuccessProcess}
            referral_url={props.referral_url}
            countryAbbreviation={props.countryAbbreviation}
            api={props.api}
            token={props.token}
            language={props.language}
            source={props.source}
            modelId={props.modelId}
            packages={props.config.packages}
          />
        )}
      </div>
    </div>
  );
};

export default ComboTypes;
